<template>
  <div>
    <b-field>
      <b-input placeholder="Filter bands" @input="getFilteredBands"></b-input>
    </b-field>
    <b-table :data="filteredBands" :bordered="false" :striped="true" :hoverable="true" :paginated="true"
            :per-page="10">
      <template slot-scope="props">

        <b-table-column field="name" label="Name">
          <b>{{ props.row.name }}</b>
        </b-table-column>

        <b-table-column field="genre" label="Genre">{{ props.row.genres }}</b-table-column>

        <b-table-column field="country" label="Country" centered>{{props.row.country}}</b-table-column>

        <b-table-column field="webiste" label="Website" centered>
          <a v-bind:href="props.row.website">{{props.row.website}}</a>
        </b-table-column>

        <b-table-column label="Edit">
          <button class="button is-small">
            <b-icon pack="fas" :icon="'edit'" @click.native="editBand(props.row)"></b-icon>
          </button>
        </b-table-column>

        <b-table-column label="Delete">
          <button class="button is-danger is-small ">
            <b-icon pack="fas" :icon="'trash'" type="is-light" @click.native="editVenue(props.row)"></b-icon>
          </button>
        </b-table-column>
      </template>
    </b-table>

<b-field grouped position="is-right">
      <p class="control addButton">
        <button class="button is-primary" @click="newBand">Add new band</button>
      </p>
    </b-field>

    <b-modal :active.sync="isNewBandDialog" has-modal-card @close="getBands">
      <CreateBand :band="selectedBand"></CreateBand>
    </b-modal>
  </div>
</template>

<script>
import BModal from "buefy/src/components/modal/Modal";
import CreateBand from "./CreateBand";

export default {
  name: "Bands",
  components: { CreateBand, BModal },
  data() {
    return {
      bands: [],
      filteredBands: [],
      selectedBand: {},
      isNewBandDialog: false
    };
  },
  methods: {
    getBands: function() {
      this.$store
        .dispatch("getBands")
        .then(() => {
          this.bands = this.$store.getters.bands
          this.filteredBands = this.bands
          })
        .catch(err => console.log(err));
    },
    editBand: function(band) {
      this.selectedBand = band;
      this.isNewBandDialog = true;
    },
    newBand: function() {
      this.selectedBand = {};
      this.isNewBandDialog = true;
    },
    getFilteredBands(text) {
          console.log("Filtered ")
      this.filteredBands = this.bands.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        );
      });
    },
  },
  mounted() {
    this.getBands();
  }
};
</script>

<style scoped>
.ddialog {
  min-width: 400px;
}
</style>
